<template>
<div>
  <v-row class='py-0' >
    <v-col cols=12 class='py-0' style='margin-top:-20px' >
      <data-form v-if='remoteMeId'
        :id='meId'
        :fields='mediaform'
        v-model='media'
        @uploadSuccess='get' />
      <v-skeleton-loader v-else full-width
        height='250' type='card'  />
    </v-col>
  </v-row>
  <request-status :request='getRequest' />
  <!-- <v-progress-linear v-if='getRequest.loading' indeterminate class='ma-0 pa-0' /> -->
  <v-row >
    <v-col cols=6 >
      <v-card class='ml-5 mb-5' >
        <v-card-title class='overline' >
          Contact details
        </v-card-title>
        <v-card-text >
          <data-form v-if='remoteMeId' :id='meId' :fields='userform' v-model='user' :request='saveUserRequest' />
          <v-skeleton-loader
            v-else
            type="card-avatar, article, actions"
          ></v-skeleton-loader>
        </v-card-text>
      </v-card>

      <v-card class='ml-5 mb-5' >
        <v-card-title class='overline' >
          Profile information
        </v-card-title>
        <v-card-text >
          <!-- <pre >{{profile}}</pre> -->
          <data-form v-if='remoteMeId' :id='meId' :fields='profileform' v-model='profile' :request='saveRequest' />
          <v-skeleton-loader
            v-else
            type="card-avatar, article, actions"
          ></v-skeleton-loader>
        </v-card-text>
      </v-card>
    </v-col >
    <v-col cols=6 >
      <center>
        <h2 class='overline'>
          <v-icon class='mr-2' >mdi-eye</v-icon>
          Preview
        </h2>
      </center>
      <practitioner-card v-if='remoteMeId' class='mr-3 elevation-10' :withEdit='false' v-model='user' />
      <!-- <pre v-text='user' /> -->
    </v-col>
  </v-row>
  <v-divider/>
  <v-row>
    <v-col cols=12 >
      <v-form @submit.prevent='changePassword' >
        <v-card full-width class='ma-5' :loading='changePasswordReq.loading' >
          <v-card-title>
          <h2 class='title' >Change your password</h2>
          </v-card-title>
          <v-divider></v-divider>
          <request-status :request='changePasswordReq' />
          <v-card-text >
              <v-text-field
                label="Enter a new password"
                hint="At least 8 characters"
                v-model="password"
                min="8"
                @click:append='passwordVisible = !passwordVisible'
                :append-icon="passwordVisible ? 'mdi-eye' : 'mdi-eye-off'"
                :type="passwordVisible ? 'text' : 'password'"
                counter >
              </v-text-field>
          </v-card-text>
          <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn type='submit'
            :disabled='!password || password.length < 8'
            :loading='changePasswordReq.loading' color='primary' >Change Password</v-btn>
          <!-- <vuex-btn @save='changePassword' :req-id='changePassReqId' text='Save' ></vuex-btn> -->
          </v-card-actions>
        </v-card>
      </v-form>
    </v-col>
  </v-row>
</div>
</template>

<script>
import Vue from 'vue'
import {mapGetters} from 'vuex'
import DataForm from '@/components/data/DataForm'
import BackgroundSelector from '@/components/ui/BackgroundSelector.vue'
import PractitionerCard from '@/components/cards/PractitionerCard.vue'
import ProfessionPicker from '@/components/pickers/ProfessionPicker.vue'

export default {
  name: 'Profile',
  components: {DataForm, PractitionerCard},
  props: {
    touch: { type: Number, default: 0 }
  },
  watch: {
    saveRequestStatus () {
      if (this.saveRequestStatus === 200) {
        this.getMe()
      }
    },
    getRequestStatus () {
      if (this.getRequestStatus === 200) {
        this.user = this.getObjectPath(this.getRequest, 'result', {})
        this.profile = this.getObjectPath(this.getRequest, 'result.profile', {})
        if (this.profile) {
          this.media = {
            background_picture: this.profile.background_picture,
            profile_picture: this.profile.profile_picture
          }
        }
      }
    },
    meId () {
      if  (this.meId) {
        this.get()
      }
    },
    imageWatcher () {
      this.saveMedia()
      this.profile.background_picture = this.media.background_picture
    },
    touch () {
      this.get()
    }
  },
  computed: {
    ...mapGetters('identity', ['me', 'meId']),
    remoteMeId () {
      if (this.user) {
        return this.user.id
      }
      return null
    },
    saveRequestStatus () {
      return this.saveRequest.status
    },
    getRequestStatus () {
      return this.getRequest.status
    },
    profileModificationDate () {
      return this.remoteProfile.modified_date
    },
    imageWatcher () {
      return this.media.background_picture
    },
    mediaform () {
      let uploadPath = `/api/v2/practitioner/me/profile/${this.meId}/`
      let vm = this
      if (!this.profile) { return [] }
      return [
        {
          id: 'background_picture',
          component: BackgroundSelector,
          containerAttrs: { xs12: true },
          attrs: {
            label: 'Choose a background image for your profile',
            hint: 'We\'ll use this image on your personal website as well as your profile for any space websites',
            withUploader: true,
            roundLogo: true,
            uploaderAttrs: {
              uploadPath,
              url: this.profile.profile_picture,
              filename: 'profile_picture',
              title: 'Profile picture',
              subtitle: 'Profile picture should be square'
            }
          },
          events: {
            uploadSuccess () {
              vm.get()
            }
          }
        }
      ]
    }
  },
  mounted () {
    if (this.me && this.me.profile) {
      // this.profile = this.me.profile
      for (let key of Object.keys(this.me.profile)) {
        Vue.set(this.profile, key, this.me.profile[key])
      }
    } else {
      this.get()
    }
  },
  methods: {
    get () {
      if (this.meId) {
        this.getRequest.resourceId = this.meId
        this.$request('get', this.getRequest)
        this.init()
      }
    },
    saveMedia () {
      if (this.meId) {
        this.saveMediaRequest.data = {
          background_picture: this.media.background_picture
        }
        this.saveMediaRequest.resourceId = this.meId
        this.$request('save', this.saveMediaRequest)
      }
    },
    changePassword () {
      this.changePasswordReq.data = {
        password: this.password
      }
      this.$request('save', this.changePasswordReq)
    }
  },
  data () {
    return {
      password: null,
      passwordVisible: false,
      resource: 'practitioner.me.profile',
      changePassReqId: 'practitioner-password-change',
      reqId: 'practitioner-settings-update',
      profile: {},
      user: {},
      media: {},
      saveUserRequest: {
        // resource: 'ag.practitioner.user'
        resource: 'ag.user'
      },
      saveRequest: {
        resource: 'ag.practitioner.profile'
      },
      saveMediaRequest: {
        resource: 'ag.practitioner.profile'
      },
      getRequest: {
        resource: 'ag.v2.practitioner.me'
      },
      changePasswordReq: {
        resource: 'ag.auth',
        extra: 'set-password'
      },
      userform: [
        {
          id: 'title',
          containerAttrs: { xs12: true, sm6: true },
          attrs: { label: 'Title' }
        },
        {
          id: 'initials',
          containerAttrs: { xs12: true, sm6: true },
          attrs: { label: 'Initials' }
        },
        {
          id: 'first_name',
          containerAttrs: { xs12: true, sm6: true },
          attrs: { label: 'First name' }
        },
        {
          id: 'last_name',
          containerAttrs: { xs12: true, sm6: true },
          attrs: { label: 'Last name' }
        },
        {
          id: 'email',
          containerAttrs: { xs12: true, sm6: true },
          attrs: { label: 'Email' }
        },
        {
          id: 'phone_number',
          containerAttrs: { xs12: true, sm6: true },
          attrs: { label: 'Phone number' }
        }
      ],
      profileform: [
        {
          id: 'registration_number',
          attrs: {
            label: 'Registration number',
            hint: 'Your personal professional registration number. For example, a BK number.'
          },
          containerAttrs: { xs12: true }
        },
        {
          id: 'profession',
          attrs: {
            label: 'Profession',
            returnObject: true
          },
          transform: (val) => {
            if (val && val.id) { return val.id }
            return null
          },
          containerAttrs: { xs12: true },
          component: ProfessionPicker
        },
        {
          id: 'description',
          attrs: {
            label: 'Bio',
            outlined: true,
            hint: 'A brief description of who you are, your qualifications and certifications'
          },
          component: 'vtextarea'
        },
        { text: 'Social Media', icon: 'mdi-bullhorn', iconColor: 'amber', id: 'heading-socia', component: 'subheader', containerAttrs: { xs12: true } },
        {
          id: 'facebook',
          attrs: {
            label: 'Facebook page or profile',
            prependIcon: 'mdi-facebook',
            hint: 'The URL to your personal Facebook page',
            placeholder: 'https://facebook.com/...'
          },
          containerAttrs: { xs12: true }
        },
        {
          id: 'linkedin',
          containerAttrs: { xs12: true },
          attrs: {
            label: 'Linkedin',
            prependIcon: 'mdi-linkedin',
            placeholder: 'https://www.linkedin.com/in/...',
            hint: 'URL to your LinkedIn profile'
          }
        },
        {
          id: 'instagram',
          containerAttrs: { xs12: true },
          attrs: {
            label: 'Instagram handle',
            model: 'instagram',
            prependIcon: 'mdi-instagram',
            placeholder: 'https://www.instagram.com/...',
            hint: 'URL to youe Instagram profile page'
          }
        },
        {
          id: 'twitter',
          containerAttrs: { xs12: true },
          attrs: {
            label: 'Twitter handle',
            model: 'twitter',
            prependIcon: 'mdi-twitter',
            placeholder: 'https://twitter.com/...',
            hint: 'URL to your Twitter handle'
          }
        },
        {
          id: 'public_phone',
          containerAttrs: { xs12: true },
          attrs: {
            label: 'Public phone number',
            model: 'public_phone',
            prependIcon: 'mdi-phone',
            persistentHint: true,
            hint: 'A public phone number to include on your public assets like websites etc. (can be different from your contact phone number)'
          }
        },
        {
          id: 'public_email',
          containerAttrs: { xs12: true },
          attrs: {
            label: 'Public email address',
            model: 'public_email',
            prependIcon: 'mdi-email',
            hint: 'A public email address to include on your public assets like websites etc. (can be different from your contact email)'
          }
        },
        { text: 'Booking widget', icon: 'mdi-bullhorn', iconColor: 'amber', id: 'heading-content-setting', component: 'subheader', containerAttrs: { xs12: true } },
        {
          id: 'website_disable_booking_widget',
          component: 'vcheckbox',
          // onlyIfTrue: 'is_website_published',
          containerAttrs: { xs12: true },
          attrs: {
            label: 'Remove book online link from personal website',
            persistentHint: true,
            hint: 'Will remove the book online button from your autogenerated personal website'
          }
        },
        { component: 'divider' },
        {
          id: 'disable_booking_widget',
          component: 'vcheckbox',
          // onlyIfTrue: 'is_website_published',
          containerAttrs: { xs12: true },
          attrs: {
            label: 'Completely disable online bookings',
            persistentHint: true,
            hint: 'Disable the online booking widget - will also disable the online booking widget when embedded on any websites'
          }
        },
        {
          id: 'disable_booking_widget_note',
          containerAttrs: { xs12: true },
          attrs: {
            label: 'Booking widget disabled reason',
            model: 'disable_booking_widget_note',
            persistentHint: true,
            hint: 'Text to show on disabled booking widget. For example, a note informing the user about your preferred booking method. Only relevant if booking widget is disabled'
          }
        },
        { component: 'divider' },
        {
          id: 'website_whatsapp_click_to_chat_number',
          containerAttrs: { xs12: true },
          attrs: {
            label: 'WhatsApp click to chat',
            model: 'disable_booking_widget_note',
            persistentHint: true,
            placeholder: '+27..',
            hint: 'Display a WhatsApp button which will start a conversation with this number'
          }
        }
      ]
    }
  }
}
</script>

<style>

</style>
